<template>
  <div class="box box-remark">
    <span class="title">Remarks</span>
    <div class="remarks-container">
      <div
        v-for="(item, index) in remarkLists"
        :key="index"
        class="remark-box">
        <div class="remark-header">
          <span>{{ item.cs_name }}</span>
          <span>{{ item.created_at }}</span>
        </div>
        <p>{{ item.message }}</p>
      </div>
    </div>
    <div class="remark-add">
      <v-input
        v-model="message"
        class="mg-b-15"
        append="Add"
        :placeholder="'Add Remarks'"
        @handlerAppend="handlerSendRemark"/>
    </div>
  </div>
</template>

<script>
import {addPolicyRemark} from '@api/policy'

export default {
  name: 'PolicyRemark',
  props:{
    pcyId:{
      type:[String,Number],
      default:0
    },
    remarkList: {
      type: Array,
      default: () => ([])
    },
  },
  data(){
    return{
      message:'',
      remarkLists:[]
    }
  },
  watch:{
    remarkList:{
      immediate:true,
      handler(val){
        this.remarkLists = val||[]
      }
    }
  },
  methods:{
    handlerSendRemark(msg) {
      if(this.message){
        this.network().addPolicyRemark()
      }
    },
    network(){
      return{
        addPolicyRemark: async () => {
          let {pcy_id} = this.$route.query
          const { data } = await addPolicyRemark({
            pcy_id: this.pcyId||Number(pcy_id),
            message: this.message,
            hideLoading:true,
          })
          this.message = ''
          // todo 追加 remark
          this.remarkLists.unshift(data)
        },
      }
    }
  }
}
</script>

<style scoped lang="scss">
.box-remark{
  border-bottom: 0!important;
}
.remark-add {
  z-index: 2;
  margin: 0 -15px;
  padding: 15px 15px 0 15px;
  //border-top: 1px solid #dddfe7;
}

.remarks-container {
  z-index: 1;
  max-height: 300px;
  overflow-y: auto;

  .remark-box {
    margin-bottom: 10px;
    font-size: 12px;
    color: #91939a;

    .remark-header {
      display: flex;
      justify-content: space-between;

      span:first-child {
        font-weight: bold;
      }
    }

    p {
      padding-bottom: 10px;
      color: #616266;
    }
  }
}
</style>
